import { excuseApi } from "../commons/http";

class CustomerPreferences {
  async getPreferences(userId) {
    try {
      const res = await excuseApi({
        path: `/users/${userId}/preferences`,
        method: 'GET',
      });
      if (res.status === 200) {
        return res.data.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching preferences:', error);
      throw error;
    }
  }

  async savePreferences(userId, data) {
    try {
      const res = await excuseApi({
        path: `/users/${userId}/preferences`,
        method: 'PUT',
        body: data,
      });
      if (res.status === 200) {
        return { success: true, data: res.data.data, message: 'Lưu sở thích thành công' };
      }
      return { success: false, message: 'Lưu sở thích thất bại' };
    } catch (error) {
      console.error('Error saving preferences:', error);
      throw error;
    }
  }
}

export default CustomerPreferences;
